import { cva, type VariantProps } from 'class-variance-authority';

export { default as Alert } from './Alert.vue';
export { default as AlertDescription } from './AlertDescription.vue';
export { default as AlertTitle } from './AlertTitle.vue';

export const alertVariants = cva(
  'relative w-full rounded-lg border border-slate-200 p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-slate-950  ',
  {
    variants: {
      variant: {
        default: 'bg-white text-slate-950',
        success: 'border-emerald-500/50 bg-emerald-100/50 text-slate-950  [&>svg]:text-slate-950',
        destructive: 'border-red-500/50 text-red-500  [&>svg]:text-red-500',
        info: 'border-sky-500/50 bg-sky-100/50 text-slate-950  [&>svg]:text-slate-950',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export type AlertVariants = VariantProps<typeof alertVariants>;
